/// <summary>
/// This visual provides a list of entries of a single DC validation email<br/>
/// </summary>    ///
/// <remarks>
/// Author: AFU<br/>
/// Date: 29.10.2025<br/>
/// Copyright ©: EUDT GmbH 2024 <br/>
/// Version-History:<br/>
/// **********************************************************************<br/>
/// *** v1.0.0 - 16.12.2025                                            ***<br/>
/// **********************************************************************<br/>
/// * - generates basic functionality                                    *<br/>
/// **********************************************************************<br/>
jQuery.widget("bluaul.DcValidationEmailList", jQuery.common.vcBaseV4, {

    defaultDaysForPlausiblities: 14,
    myData: { entries: null},
    myStatus: { emailHash: "",  selectedBsaids: [], plausSaved: false },
    _create: function () {
        this._createVisual(397);
        this._super();
    },
    _initHTML: function () {
        var me = this;
        try {
            me._setRoot(".vc-dc-validation-emaillist");
            
            me.myStatus.emailHash = me.options.parameter.EmailHash;
            me._buildHtml();
            me._setHeightsAndWidths();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initEvents: function () {
        var me = this;
        try {

            //init event listener
            _VCMQ.addConsumer(me.vcgid);
            _VCMQ.consume(me.visual, me.vcgid, function (event) { me._doEvent(event) });

            me._initStructure();

            me._fetch();

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _buildHtml: function () {
        /// <summary>
        /// This function builds the html structure
        /// </summary>
        var me = this;
        try {
            me.myHtml = {
                actionMenu: {}, filterMenu: {}, list: {}, plausPopup: {}, archivePopup: {}
            };

            //action menu
            obj = me.myHtml.actionMenu;
            obj.wrapper = me._setWrapper("action-menu", "vc-grid-margin-top");

            obj.btnArchive = me._setMainButton("", "<i class='fa-regular fa-chart-column' ></i>", me.specific.resources.archive).addClass("active").css("float", "right").css("margin-top", "4px");



            obj.plausWrapper = me._setObj("", "info-box vc-grid-5col vc-grid-margin-right float-box");
            obj.plausNote = me._setObj("", "").html(me.specific.resources.InfoSetTempAnomalyPlausibility);
            obj.plaus = me._setObj("", " vc-grid-2col").html(me.specific.resources.setTempAnomalyPlausibility);
            obj.plausWrapper.append(obj.plausNote, $("<br/>"), obj.plaus);

            obj.ticketWrapper = me._setObj("", "info-box vc-grid-5col vc-grid-margin-right float-box");
            obj.ticketNote = me._setObj("", "").html(me.specific.resources.InfoCreateNewTicket);
            obj.ticket = me._setObj("", " vc-grid-2col").html(me.specific.resources.createNewTicket);
            obj.ticketWrapper.append(obj.ticketNote, $("<br/>"), obj.ticket);
            obj.wrapper.append(obj.ticketWrapper, obj.plausWrapper, obj.btnArchive);


            //filter menu
            obj = me.myHtml.filterMenu;
            obj.wrapper = me._setWrapper("filter-menu", "vc-grid-margin-top");
            obj.chbSelectAll = me._setInput("chb-select-all", "").attr("type", "checkbox").attr("id", "chb-select-all");
            obj.lblSelectAll = "<label for='chb-select-all' style='margin-left:3px'>" + me.specific.resources.selectAll + "</label>";

            obj.boxSelectAll = me._setObj("", "vc-grid-margin-right float-box").append(obj.chbSelectAll, obj.lblSelectAll);
            obj.chbFilterDone = me._setInput("chb-filter-done", "").attr("type", "checkbox").attr("id", "chb-filter-done");
            obj.lblFilterDone = "<label for='chb-filter-done' style='margin-left:3px'>" + me.specific.resources.hideDoneEntries + "</label>";
           
            obj.boxFilterDone = me._setObj("", " float-box").append(obj.chbFilterDone, obj.lblFilterDone);
            obj.wrapper.append(obj.boxSelectAll, obj.boxFilterDone);
           

         
            //signal list
            obj = me.myHtml.list;
            obj.wrapper = me._setWrapper("", "vc-list ").css("border", "1px solid #ddd");
            obj.header = me._setListHeader("");
            // generate header list
            var line = me._setListItem();
            line.column.append(me._setListElement("", "w5").html(me.specific.resources.selection).css("text-align", "center"));
         
           
            line.column.append(me._setListElement("", "w8").html(me.specific.resources.currentState));
            line.column.append(me._setListElement("", "w8").html(me.specific.resources.statusModification));
            line.column.append(me._setListElement("", "w8").html(me.specific.resources.anomalyPlausibilityIsSet));
            line.column.append(me._setListElement("", "w5").html(me.specific.resources.ticket));
            line.column.append(me._setListElement("", "w20").html(me.specific.resources.signals));
            line.column.append(me._setListElement("", "w10").html(me.specific.resources.date));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.description));
            line.column.append(me._setListElement("", "w15").html(me.specific.resources.commit));
            line.column.append(me._setListElement("", "w3").html("<br/>"));

            obj.header.append(line.item);
            obj.entries = me._setObj("entries", "vc-list-table");
            obj.wrapper.append(obj.header, obj.entries);

            me.myRoot.append(me.myHtml.actionMenu.wrapper, me.myHtml.filterMenu.wrapper, me.myHtml.list.wrapper);


            //add plaus popup
            obj = me.myHtml.plausPopup;
            obj.wrapper = me._setWrapper("", "vc-list ");
            obj.header = $("<div>").addClass("vc-list-header-simple vc-grid-margin-bottom").html("");
            obj.menu = $("<div>").attr("id", "div-edit").addClass("vc-grid-margin-top vc-grid-margin-bottom");

            obj.info = me._setObj("date", "note vc-grid-margin-bottom").html(me.specific.resources.InfoSetTempAnomalyPlausibility);
            obj.date = me._setObj("date", "vc-grid-2col float-box");

            obj.save = $("<div>").attr("id", "div-save float-box").html(me.specific.resources.saveSelection);

            obj.menu.append(obj.info, obj.date, obj.save);

            obj.wrapper.append(obj.header, obj.menu);

            //add plaus popup
            obj = me.myHtml.archivePopup;
            obj.wrapper = me._setWrapper("", "xxxxxx ");





        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _initStructure: function () {
        /// <summary>
        /// This function inits various events and handlers
        /// </summary>
        var me = this;
        try {
           //init plaus popup
            me._initPlausDialog(700, 730);
            me._initPlausDate(null, false);

            me.myHtml.plausPopup.save.off("click").on("click", function () {
                _VCMQ.produce(me.visual, me.vcgid, 'RELOAD_DC_EMAILLIST', $(this));
            }).button();

            me.myHtml.actionMenu.plaus.off("click").on("click", function () {
                me._openPlausPopup(me.specific.resources.setTempAnomalyPlausibility);
            }).button();

           //init ticket popup
            me._initEditDialog(0.95, 0.95, "vc-menu", function (obj) {
                //reset html of dialog
                me.editDialog.html("");
            });

            me._initArchiveDialog(0.95, 0.95);


            me.myHtml.actionMenu.btnArchive.off("click").on("click", function () {
                me._selectSignalList();
                if (me.myStatus.selectedBsaids.length == 0) {
                    me.openInfoDialog(me.specific.resources.noSelection, { at: 'center center-20%', of: window });
                    return true;
                }

                me._openArchivePopup(me.myStatus.selectedStartDate, me.settings.blid, me.myStatus.selectedBsaids);

            })



            me.myHtml.actionMenu.ticket.off("click").on("click", function () {
                me._selectSignalList();
                if (me.myStatus.selectedBsaids.length == 0) {
                    me.openInfoDialog(me.specific.resources.noSelection, { at: 'center center-20%', of: window });
                    return true;
                }
             
                // get selected bsaids for pre-selecting these signals in the ticket widget
                var startEntry = {Blid: me.settings.blid,Assignments: { Assignments: []},
                    Data: {
                        Priority: 6, TaskID: 2, StartDate: moment(me.myStatus.selectedStartDate, "DD.MM.YYYY").format("DD.MM.YYYY"),
                        Description: 'validation email from ' + moment(me.myData.entries[0].Date, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY HH:mm:ss") + ' h'
                        }
                    };
                //add selected signals to ticket
                me.myStatus.selectedBsaids.forEach(function (bsaid) {
                    startEntry.Assignments.Assignments.push({ AssId: bsaid, TypeId: 2});
                });


                me.vcV.showSingleTicketDialog(me.settings.blid, { "TicketID": -1, LoggerID: me.settings.blid, readOnlyMode: false, startEntry: startEntry });
            }).button();

            me.myHtml.filterMenu.chbSelectAll.off("click").on("click", function () {
                me._selectAll();
            });
            me.myHtml.filterMenu.chbFilterDone.off("click").on("click", function () {
                me._filterDone();
            });




        } catch (e) { me._writeErr(e); }
    },
    _initPlausDialog: function (w, h) {
        /// <summary>
        /// This function inits the plausibility popup
        /// </summary>
        var me = this;
        var h, w;
        try {
            me.plausDialog = null;
            me.myDiv = $("<div>").attr("id", "div-dialog").css("z-index", 10000);
            var options = { autoOpen: false, width: w, height: h, modal: true, dialogClass: "modal-popup-dialog" };

            options.buttons = [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    me.plausDialog.dialog('close');
                    return true;
                }
            }];

            me.plausDialog = me.myDiv.dialog(options);

            me.plausDialog.width = w;
            me.plausDialog.height = h;
            me.myHtml.plausPopup.wrapper.width(w - 27).height(h - 100);
            me.plausDialog.html(me.myHtml.plausPopup.wrapper);


            return true;
        } catch (e) { me._writeErr(e); return false; }
    },

    
    _initArchiveDialog: function (widthInPercent, heightInPercent) {
        /// <summary>
        /// This function inits the plausibility popup
        /// </summary>
        var me = this;
        var h, w;
        try {
            me.archiveDialog = null;
            me.myDiv = $("<div>").attr("id", "div-dialog").css("z-index", 10000);



            var size = me.getPopupSize(widthInPercent, heightInPercent);
            var w = size[0];
            var h = size[1];

            var options = { autoOpen: false, width: w, height: h, modal: true, dialogClass: "modal-popup-dialog" };

            options.buttons = [{
                text: window._RESOURCES.JS_Com.close_lbl, click: function () {
                    me.archiveDialog.dialog('close');
                    return true;
                }
            }];

            me.archiveDialog = me.myDiv.dialog(options);



            me.archiveDialog.width = w;
            me.archiveDialog.height = h;
            me.myHtml.archivePopup.wrapper.width(w - 27).height(h - 100);


            me.archiveDialog.html(me.myHtml.archivePopup.wrapper);


            return true;
        } catch (e) { me._writeErr(e); return false; }
    },



    _openArchivePopup: function (day, loggerId,  selectedBsaids) {
        /// <summary>
        /// This function opens the archive popup and inits a simple archive chart
        /// </summary>
        var me = this;

        try {
          
            me.archiveDialog.dialog("open");
            me.myHtml.archivePopup.wrapper.RampArchive({ invokeType: "addVisualContent", parameter: { Day: day, LoggerId: loggerId, PopupIdentifier: 1234, SelectedBsaids: selectedBsaids } });
            return true;

        } catch (e) { me._writeErr(e); return false; }
    },


    _initPlausDate: function (dateRange, update) {
        /// <summary>
        /// This function inits - and reinits - the date box in the plaus popup
        /// </summary>
        var me = this;

        try {
            if (update) me.myHtml.plausPopup.date.vcDate("destroy"); 

            var options = { mode: "Range", align: "right", interval: 1,  langID: me.settings.userLangIDForCulture, callback: function (obj) { me.myStatus.dateRange = obj.dateRange; } };
            if (dateRange != null) { options.defaultRange = dateRange };

            me.myHtml.plausPopup.date.vcDate(options);

        } catch (e) { me._writeErr(e);  }
    },
    _openPlausPopup: function (caption) {
        /// <summary>
        /// This function opens the plaus popup and sets a new starting date
        /// </summary>
        var me = this;

        try {
            //we set a new flag - (so we avoid duplicate savings due to the calender item)
            me.myStatus.plausSaved = false;
            //console.info("set plaus flag: " + me.myStatus.plausSaved);
            me.myHtml.plausPopup.header.html(caption);
            me._selectSignalList();

            if (me.myStatus.selectedBsaids.length == 0) {
                me.openInfoDialog(me.specific.resources.noSelection, { at: 'center center-20%', of: window });
                return true;
            }

            //restore the date box with the new time span
            me._initPlausDate({ from: me.myStatus.selectedStartDate, to: moment(me.myStatus.selectedStartDate).add(me.defaultDaysForPlausiblities, 'd') }, true);
            me.plausDialog.dialog("open");

            return true;

        } catch (e) { me._writeErr(e); return false; }
    },
    _savePlaus: function () {
        /// <summary>
        /// This function stores the new plausibility settings and reloads the email list
        /// </summary>
        var me = this;
        try {
            //console.info("get plaus flag: " + me.myStatus.plausSaved);
            if (!me.myStatus.plausSaved) {
                me.myStatus.plausSaved = true;
                var dates = me.myStatus.dateRange;

                var param = { TypeId: 1, EmailHash: me.myStatus.emailHash, selectedBsaids: me.myStatus.selectedBsaids, StartDate: dates.from, EndDate: dates.to }
                me.updateData(param, function (result) {
                    //check response content
                    if (result == null) {
                        me.showMessage(me.resources.err_loadData, true); // TODO
                        return true;
                    }
                    me.myStatus.plausSaved = true;
                    me._fetch();
                    return true;
                });
            }

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _fetch: function () {
        /// <summary>
        /// This function fetches the data based on the current setings
        /// </summary>
        var me = this;
        try {

            me._setLoadingIcon(me.myHtml.list.entries);
            var param = { TypeId: 1, EmailHash: me.myStatus.emailHash }
            me.getData(param, function (result) {

                //check response content
                if (result == null) {
                    me.showMessage(me.resources.err_loadData, true); // TODO
                    return true;
                }
                me.myData.entries = result;
                me._generateList();

                //init the dc-edit icon handler
                me.myHtml.list.entries.find('.btn-DcEdit').off("click").on("click", function (e) {
                    me.vcV.showDsEdit2Dialog({ LoggerId: $(this).data("blid"), bsaid: $(this).data("bsaid"), day: $(this).data("date") });
                    e.stopPropagation();
                });

                //init the archive icon handler
                me.myHtml.list.entries.find('.btn-archive').off("click").on("click", function (e) {
                    me._openArchivePopup($(this).data("date"), $(this).data("blid"), [$(this).data("bsaid")]);
                  
                    e.stopPropagation();
                });

                //init the ticket icon handler
                me.myHtml.list.entries.find('.btn-tickets').off("click").on("click", function (e) {
                    me.editDialog.dialog("open");
                    me.myDiv.TicketList({ invokeType: "addVisualBase", parameter: { "ReadOnlyMode": true, 'SignalID': $(this).data("bsaid"), LoggerID: $(this).data("blid") } });


                   
                    e.stopPropagation();
                });


            });

        } catch (e) { me._writeErr(e); return false; }
        return true;
    },
    _generateList: function () {
        /// <summary>
        /// This function generates a list from the data
        /// </summary>
        var me = this;

        try {

            if (me.myData.entries.length == 0) {
                me.myHtml.list.entries.html($("<br>")).append($("<div>").addClass("note").html(me.resources.noEntriesExist));
                me.myStatus.emailHash = ""
                return false;
            }

            //clear list
            me.myHtml.list.entries.html("");

            // fill entry list
            $.each(me.myData.entries, function (key, row) {
         
                me.myHtml.list.entries.append(me._fillRow(row));
            });

            me.myHtml.list.entries.find(".vc-list-item").addClass("found");
            me._setAltListStyle(me.myHtml.list.entries);

            return true;

        } catch (e) { me._writeErr(e); return false; }
    },
    _fillRow: function (row) {
        /// <summary>
        /// This function fills the list with all corresponding items
        /// </summary>
        var me = this;
        try {

            //console.info(row);
            //console.info(row.SortId + "  " + row.Signal);


            var line = me._setListItem();
            line.item.data("bsaid", row.Bsaid);

            var bDone = false;
            var bIgnore = false;
            var cssIgnore = "";
            //disturbance plaus set
            if (row.HasDisturbancePlausibility) bIgnore = true;

         
            ////values ok again
            if (row.CurrentDescription.length == 0) {
                bDone = true;
                bIgnore = true;
                line.item.addClass("done");
            }
           
            if (bIgnore)  cssIgnore = " ignore";
            var descr = $("<div>");
           
            if (row.CurrentDescription.length > 0 && row.CurrentDescription != row.Description) {
                descr.append($("<span>").addClass("ignore").html(row.Description), $("<br>"), $("<span>").html(row.CurrentDescription));
            } else {
                descr.append($("<span>").addClass(cssIgnore).html(row.Description));
            }

            let chkSelect =  me._setInput("", "chb-select").attr("type", "checkbox").prop("name", "chb-select");
        
         
            line.column.append(me._setListElement("select", "w5").css("text-align", "center").html(chkSelect).append($("<br>")));
           
            
            line.column.append(me._setListElement("", "w8 vc-list-icon").html(bDone? me.specific.resources.iconOk : me.specific.resources.iconInvalid));
            line.column.append(me._setListElement("", "w8 vc-list-icon").html((row.Description != row.CurrentDescription) ? !bIgnore ? me.specific.resources.iconOk : "-" : "-"));
            line.column.append(me._setListElement("", "w8 vc-list-icon").html(row.HasDisturbancePlausibility ? me.specific.resources.iconOk : "-"));
            line.column.append(me._setListElement("", "w5").html(row.HasTicket ? "<i data-bsaid='" + row.Bsaid + "' data-blid='" + row.Blid + "' title='" + me.specific.resources.ticket + "' class='vc-list-icon btn-tickets fa-regular fa-ticket color-font-secondary' ></i>" : "<br/>"));
            line.column.append(me._setListElement("signal", "w20" + cssIgnore).html(row.Signal));
            line.column.append(me._setListElement("date", "w10" + cssIgnore).data("date", row.LeakDate).html(moment(row.LeakDate, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY HH:mm") + " h"));
            line.column.append(me._setListElement("", "w15").html(descr));
            line.column.append(me._setListElement("", "w15 smaller").html(row.CommitText.length > 0 ? row.CommitText : "<br/>"));


            var dcIcon = "<br/>";

            if (me.specific.isAdmin) {
                dcIcon = "<i data-bsaid='" + row.Bsaid + "' data-blid='" + row.Blid + "' data-date='" + moment(row.LeakDate, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY") + "' class='btn-DcEdit vc-list-icon fa-regular fa-laptop-medical icon-color-info' ></i>";
            } else {
                dcIcon = "<i data-bsaid='" + row.Bsaid + "' data-blid='" + row.Blid + "' data-date='" + moment(row.LeakDate, "DD.MM.YYYY HH:mm").format("DD.MM.YYYY") + "' class='btn-archive vc-list-icon fa-regular fa-chart-column icon-color-info' ></i>";
            }
            line.column.append(me._setListElement("", "w3").html(dcIcon));

            return line.item;
        } catch (e) {me._writeErr(e); return false; }
    },
    _filter: function () {
        this._doListTableFilter(this.myHtml.list.entries);
        this._filterDone();
    },
    _filterDone: function (event) {
        /// <summary>
        /// show/hides done entries
        /// </summary>
        var me = this;
        try {
            if (me.myHtml.filterMenu.chbFilterDone.prop("checked")) {
                me.myHtml.list.entries.find(".vc-list-item.done").hide();
            } else {
                me.myHtml.list.entries.find(".vc-list-item.done").show();
            }
        } catch (e) { me._writeErr(e); }
    },
    _selectSignalList: function () {
        /// <summary>
        /// This function generates a list of selected bsaids and the earliest selected date
        /// </summary>
        var me = this;

        try {

            let lstBsaid = [];
            let startDate = null;
            //get all selected bsaids
            $.each(me.myHtml.list.entries.find(".vc-list-item:visible"), function (e) {
                let item = $(this);
                let select = item.find("#select .chb-select");
                if (select.length > 0) {
                    if (select.prop("checked")) {
                        let dt = item.find("#date").data("date");
                        //get the earliest start ate
                        if (startDate == null) {
                            startDate = dt;
                        } else {
                            if (startDate > dt) {
                                startDate = dt;
                            }
                        }
                        if (lstBsaid.indexOf(item.data("bsaid")) < 0) {
                            lstBsaid.push(item.data("bsaid"));
                        }
                    }
                }
            });

            me.myStatus.selectedBsaids = lstBsaid;
            me.myStatus.selectedStartDate = startDate;


        } catch (e) { me._writeErr(e); }
    },
    _selectAll: function (event) {
        /// <summary>
        /// selects/unselects entries
        /// </summary>
        var me = this;
        try {
            var check = me.myHtml.filterMenu.chbSelectAll.prop("checked");
            $.each(me.myHtml.list.entries.find(".vc-list-item:visible"), function (e) {
                $(this).find("#select .chb-select").prop("checked", check);
            });


        } catch (e) { me._writeErr(e); }


    },
    _doEvent: function (event) {
        /// <summary>
        /// Handles different internal and external events
        /// </summary>
        var me = this;
        try {
          
            switch (event.msg) {
                case 'RELOAD_DC_EMAILLIST':
                    me._savePlaus();
                    me.myStatus.plausSaved = true;
                    me.plausDialog.dialog("close");
                    break;
                case 'TICKETS_CHANGED':
                    me._fetch();
                    break;

                default: break;
            }
        } catch (e) { me._writeErr(e);  }
    },
    _setHeightsAndWidths: function () {
        /// <summary>
        /// This function calculates and sets the height of elements relatively to the general content height
        /// </summary>
        var me = this;
        try {

            let h = me._getVisualHeight();

            //set height of main signal list
            let listH = h - me.myHtml.actionMenu.wrapper.outerHeight() - me.myHtml.filterMenu.wrapper.outerHeight() - me.myHtml.list.header.outerHeight() - 40; 
            me.myHtml.list.entries.css("height", listH).css("maxHeight", listH);

        } catch (e) { me._writeErr(e); }
    },
    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.myHtml.actionMenu.hide();
                me.myHtml.list.hide();
            }
            return true;
        } catch (e) {
            me.writeError(e); return false;
        }
    }
});